export default __webpack_public_path__ + "static/SanFranciscoText-Regular-3833d9cb09297a592e2d0a5534516ecb.otf";